

import React from 'react';

import './style.css'

import successIcon from '../../assets/success-icon.png';

interface IModalProps {
    message: string,
    isOpen: boolean,
    onClose: () => void
}

const SuccessModal: React.FC<IModalProps> = ({message, isOpen = false, onClose  }) => {


    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className='center-middle'>
                <div className="icon-size-2">
                    <img className="responsive-image" src={successIcon} />
                </div>
            </div>
            <br />
            <div className='center-middle font-size-17px'>
               {message}
            </div>
            <br />
            <div className="center-middle">
                <button type="button" className='btn-green-2 center-middle' onClick={onClose} >Ok</button>
            </div>
          </div>
        </div>
      );

}

export default SuccessModal;